module.exports = __webpack_public_path__ + "img/1F1EB-1F1F7.c53b3299.svg";